import React from "react";

type Props = {
    discountPrice: number;
    finalPrice: number;
    purchasePrice: number;
    sellingPrice: number;
    discountType: boolean;
    onDiscountTypeChange: (checked: boolean) => void;
    renderInput: (label: string, name: any, ...rest: any[]) => React.ReactNode;
    uomDisabled: boolean;
    wholeSalePrice: number;
};

export default function PricingSection({
    discountPrice, finalPrice, purchasePrice, sellingPrice, wholeSalePrice,
    discountType, onDiscountTypeChange, renderInput, uomDisabled,
}: Props) {
    const finalColor =
        finalPrice < purchasePrice
            ? "text-red-500"
            : purchasePrice === finalPrice
                ? "text-orange-400"
                : "text-green-600";

    return (
        <>
            <div className="flex gap-2">
                {renderInput("Selling Price", "sellingPrice", "text", false, true, uomDisabled)}
                <div className="flex flex-col gap-1 items-end w-1/2">
                    <div className="flex flex-col justify-end items-end -mb-7 w-full gap-1 mr-4">
                        <div className="flex gap-2 justify-center items-center">
                            <p className="select-none">in %</p>
                            <input
                                type="checkbox"
                                checked={discountType}
                                onChange={(e) => onDiscountTypeChange(e.target.checked)}
                                className="cursor-pointer scale-125"
                            />
                        </div>
                    </div>
                    <div className="w-full">{renderInput("Discount", "discount", "text", false, true)}</div>
                </div>
            </div>


            <div className="w-full flex justify-between items-center gap-2">
                <div className="flex w-1/2">
                    <p>Discount Value :</p>
                    <p>{discountPrice.toFixed(2)}</p>
                </div>
                <div className={`flex w-1/2 ${finalColor}`}>
                    <p>Final Price :</p>
                    <p>{finalPrice.toFixed(2)}</p>
                </div>
            </div>

            {renderInput("Whole Sale Price", "wholeSalePrice", "text", false, true, uomDisabled)}

            {purchasePrice > sellingPrice && (
                <p className="text-red-600 text-sm font-medium flex justify-center items-center">
                    ⚠️ Are you sure the selling price <br />
                    is less than the purchase price?
                </p>
            )}
        </>
    );
}